import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/storage';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loader: false,

    images: [],
    drink1: [],
    drink2: [],
    drink3: [],
    drink4: [],
    drink5: [],
    drink6: [],
    drink7: [],
    drink8: [],
    drink9: [],
    drink10: [],
    drink11: [],
    drink12: [],
    drink13: [],
    drink14: [],
    drink15: [],
    drink16: [],

  },
  mutations: {
    Loader(state, payload) {
      state.loader = payload;
    },

    getImage(state, value) {
      state.images = [];
      firebase.firestore().collection(value).orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.images.push(doc);
        })
      }).catch(() => {

        alert('Something went wrong , please try again.');

      });
    },


    getDrink(state) {
      state.drink1 = [],
        state.drink2 = [],
        state.drink3 = [],
        state.drink4 = [],
        state.drink5 = [],
        state.drink6 = [],
        state.drink7 = [],
        state.drink8 = [],
        state.drink9 = [],
        state.drink10 = [],
        state.drink11 = [],
        state.drink12 = [],
        state.drink13 = [],
        state.drink14 = [],
        state.drink15 = [],
        state.drink16 = [],


        firebase.firestore().collection("Hot Beverages").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            state.drink1.push(doc);
          })
        });

      firebase.firestore().collection("Cold Beverages").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink2.push(doc);
        })
      });
      firebase.firestore().collection("Flavour Cappuccino").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink3.push(doc);
        })
      });
      firebase.firestore().collection("Frappuccino").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink4.push(doc);
        })
      });
      firebase.firestore().collection("Smoothie").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink5.push(doc);
        })
      });
      firebase.firestore().collection("Soda Drink").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink6.push(doc);
        })
      });
      firebase.firestore().collection("Coffee Liqueur").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink7.push(doc);
        })
      });
      firebase.firestore().collection("Fresh Juice & Soft Drink").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink8.push(doc);
        })
      });
      firebase.firestore().collection("Cocktail").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink9.push(doc);
        })
      });
      firebase.firestore().collection("Aperitifs & Gin, Vodka").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink10.push(doc);
        })
      });
      firebase.firestore().collection("Beer, Rum & Tequila, Liqueur").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink11.push(doc);
        })
      });
      firebase.firestore().collection("Wine(Red Wine,White Wine)").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink12.push(doc);
        })
      });
      firebase.firestore().collection("Whisky").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink13.push(doc);
        })
      });
      firebase.firestore().collection("Whisky(Bourbon,Irish,Cognac)").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink14.push(doc);
        })
      });
      firebase.firestore().collection("Whisky(Duty Free)").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink15.push(doc);
        })
      });
      firebase.firestore().collection("Tai Kitchen's Corkage Charges,Bottle Charges").orderBy('timestamp', 'desc').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          state.drink16.push(doc);
        })
      });


    },

    uploadImage(state, { collection, imageUrl }) {
      firebase.firestore().collection(collection).add({
        "imageUrl": imageUrl,
        "timestamp": Date.now() + "",
      }).then(() => {

        console.log('Upload successful.')
        alert('upload successful');

      }).catch((error) => {

        console.log(error.message)

      })
    },

    uploadImageForDrink(state, { selectedDrink, imageUrl }) {
      firebase.firestore().collection(selectedDrink).add({
        "imageUrl": imageUrl,
        "timestamp": Date.now() + "",
      }).then(() => {

        console.log('Upload successful.')
        alert('upload successful');

      }).catch((error) => {

        console.log(error.message)

      })
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {

    getImages: (state) => {
      return state.images;
    },

    getDrink1: (state) => {
      return state.drink1;
    },

    getDrink2: (state) => {
      return state.drink2;
    },
    getDrink3: (state) => {
      return state.drink3;
    },
    getDrink4: (state) => {
      return state.drink4;
    },
    getDrink5: (state) => {
      return state.drink5;
    },
    getDrink6: (state) => {
      return state.drink6;
    },
    getDrink7: (state) => {
      return state.drink7;
    },
    getDrink8: (state) => {
      return state.drink8;
    },
    getDrink9: (state) => {
      return state.drink9;
    },
    getDrink10: (state) => {
      return state.drink10;
    },
    getDrink11: (state) => {
      return state.drink11;
    },
    getDrink12: (state) => {
      return state.drink12;
    },
    getDrink13: (state) => {
      return state.drink13;
    },
    getDrink14: (state) => {
      return state.drink14;
    },
    getDrink15: (state) => {
      return state.drink15;
    },
    getDrink16: (state) => {
      return state.drink16;
    },
  }
})
